export default __webpack_public_path__ + "static/check-gift-card-025550441eaf0c53d9f9dc780a7713f5.png";